// Captures the partner referral slug from common query-string formats
// (`?ref=`, `?partner=`, `?p=`, `?slug=`, `?id=`) on ANY page load and
// persists it to localStorage so a later Register page submit can attribute
// the lead to the partner — even if the partner ref-link doesn't point to
// `/register/{slug}` directly.

const STORAGE_KEY = "alphalane_ref_slug";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

const REF_PARAMS = ["ref", "partner", "p", "slug", "id"];
const SLUG_RE = /^[a-zA-Z0-9_-]{2,40}$/;

export function captureRefFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    for (const key of REF_PARAMS) {
      const val = params.get(key);
      if (val && SLUG_RE.test(val)) {
        const slug = val.toLowerCase();
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({ slug, ts: Date.now() })
        );
        return slug;
      }
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function getStoredRefSlug() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const { slug, ts } = JSON.parse(raw);
    if (!slug || !ts) return null;
    if (Date.now() - ts > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return slug;
  } catch {
    return null;
  }
}

export function clearStoredRefSlug() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
